import { RolesWithPermissions } from '../';

export const DOB_INSPECTORS_ROLES: RolesWithPermissions = {
  admin: {
    dobInspectors: {
      view: true,
      create: false,
    },
  },
  general: {
    dobInspectors: {
      view: true,
      create: false,
      update: false,
      deactivate: false,
    },
  },
  supervisor: {
    dobInspectors: {
      view: true,
      create: true,
      update: true,
      deactivate: true,
    },
  },
  backoffice: {
    dobInspectors: {
      view: true,
      create: true,
      update: true,
      deactivate: true,
    },
  },
  client: {
    dobInspectors: {
      view: false,
      create: false,
    },
  },
  agency: {
    dobInspectors: {
      view: false,
      create: false,
    },
  },
  '3rd_inspector': {
    dobInspectors: {
      view: false,
      create: false,
    },
  },
  inspector: {
    dobInspectors: {
      view: false,
      create: false,
    },
  },
};
